export function Field({ label, children, testid }) {
  return (
    <div data-testid={testid} className="space-y-2">
      <label className="overline">{label}</label>
      {children}
    </div>
  );
}

export function TextInput({ value, onChange, placeholder, testid }) {
  return (
    <input
      type="text"
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="input-line"
      data-testid={testid}
    />
  );
}

export function TextArea({ value, onChange, placeholder, rows = 4, testid }) {
  return (
    <textarea
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      rows={rows}
      className="input-line resize-y"
      data-testid={testid}
    />
  );
}

export function SectionCard({ title, description, children }) {
  return (
    <section className="bg-white border border-[var(--line)] p-6 md:p-8">
      <div className="border-b border-[var(--line)] pb-4 mb-6">
        <h3 className="font-serif-display text-2xl">{title}</h3>
        {description && (
          <p className="text-sm text-[var(--ink-soft)] mt-1">{description}</p>
        )}
      </div>
      <div className="space-y-6">{children}</div>
    </section>
  );
}
